import { ColoursObj, MainButton, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { ChatUnavailable } from "../../assets/illustrations/ChatUnavailable";
import { useGlobalRouter } from "../globalRouter/useGlobalRouter";
export const NotFoundPage = () => {
  const { goBack } = useGlobalRouter();
  return (
    <Stack
      style={{
        backgroundColor: ColoursObj.shades.shade5,
      }}
    >
      <Stack
        style={{
          display: "flex",
          flexDirection: "column",
          width: "var(--app-width)",
          height: "100%",
          paddingTop: "20vh",
          gap: "16px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ChatUnavailable />
        <Stack
          style={{
            gap: "16px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="mobileH1" sx={{
            textAlign: "center"
          }}>
            Page not found
          </Typography>

          <MainButton
            text="Go back"
            onClick={() => goBack()}
            style={{ width: "fitContent" }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
